import { AxiosResponse } from "axios";
import {
  IAppointmentCancelPayload,
  IAppointmentCancelResponse,
  IAppointmentCreatePayload,
  IAppointmentCreateResponse,
  IAppointmentTicketPayload,
  IAppointmentTicketResponse,
} from "~/types/appointment";

import { egisApi } from "~/utils/api";

// Note: Сервис получение талонов
export const fetchAvailableTicketsService = (
  payload: IAppointmentTicketPayload
) => {
  return egisApi.post<
    IAppointmentTicketResponse,
    AxiosResponse<IAppointmentTicketResponse, typeof payload>,
    typeof payload
  >(`/tickets`, payload);
};

// Note: Сервис записи к врачу
export const createAppointmentService = (
  payload: IAppointmentCreatePayload
) => {
  return egisApi.post<
    IAppointmentCreateResponse,
    AxiosResponse<IAppointmentCreateResponse, typeof payload>,
    typeof payload
  >(`/ticket/accept`, payload);
};

// Note: Сервис отмены записи к врачу
export const cancelAppointmentService = (
  payload: IAppointmentCancelPayload
) => {
  return egisApi.post<
    IAppointmentCancelResponse,
    AxiosResponse<IAppointmentCancelResponse, typeof payload>,
    typeof payload
  >(`/ticket/refuse`, payload);
};
